import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Events } from 'ionic-angular';
import { TabsPage } from "../../pages/tabs/tabs";
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-dater',
  templateUrl: 'dater.html',
})
export class DaterPage {
  private when: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, public dataProvider: DataProvider) {
    events.subscribe("home:when", (data) => {
      if (this.dataProvider.whenPost == undefined) {
        this.when = data;
      }
      else {
        this.when = this.dataProvider.whenPost.toISOString();
      }
    });
  }

  ionViewDidLoad() {
    //    console.log("1");
  }

  ionViewWillEnter() {
    //    console.log("2");
  }

  ionViewDidEnter() {
    //    console.log("3");
  }

  ionViewWillLeave() {
    //    console.log("4");
  }

  ionViewDidLeave() {
    //    console.log("5");
  }

  ionViewWillUnload() {
    //    console.log("6");
  }

  ionViewCanEnter() {
    //    console.log("7");
  }

  ionViewCanLeave() {
    //    console.log("8");
  }

  public changeDate() {
    this.events.publish("dater:when", this.when);
    this.dataProvider.whenPost = new Date(this.when);
    this.navCtrl.push(TabsPage, this.when);
  }

  public thisMonth() {
    let date = new Date().toISOString();
    this.dataProvider.whenPost = new Date(date);
    this.navCtrl.push(TabsPage, date);
  }
}


// WEBPACK FOOTER //
// ./src/pages/dater/dater.ts